var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 763.76 314.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#151828;}.cls-2{fill:#fbbb2e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attendix_logo_text",
    "data-name": "Attendix logo + text"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.26,
    cy: 37.65,
    r: 37.65,
    transform: "translate(-8.91 30.52) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.45,191.11s-.84-41.84,70.7-55.65c84.1-16.23,72.38-70.7,72.38-70.7s-6.26,31-90.79,31C11.09,95.72,18.62,135,37.45,191.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,314.11S16.53,272.55,83.75,243c70.35-31,49.64-88.17,49.64-88.17s2.18,34-80,53.58C-21.69,226.25-5.23,261.4,28,314.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.21,204.11H236.29l-8.37,20.69H207.31l39.37-95.29h20.15L306.2,224.8H285.59Zm-6.66-16.61-13.8-34L243,187.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331,174v18.64q0,8.18,3.25,11.71t10.7,3.54v17.29q-15.66,0-24.88-8t-9.22-24.51V174H299.38V156.74h11.47V129.65H331v27.09H345V174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.6,174v18.64q0,8.18,3.25,11.71t10.7,3.54v17.29q-15.66,0-24.88-8t-9.22-24.51V174H349V156.74h11.47V129.65H380.6v27.09h13.95V174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.17,173.41a37.51,37.51,0,0,1,14.26-12.93,41.66,41.66,0,0,1,19.91-4.83,47,47,0,0,1,19.07,4,38.62,38.62,0,0,1,15.11,11.64,29.86,29.86,0,0,1,6.28,18,37.87,37.87,0,0,1-.62,8.44H421.67a13.3,13.3,0,0,0,6.13,8,21.44,21.44,0,0,0,11.54,2.93,23.37,23.37,0,0,0,7.83-1.09,22.24,22.24,0,0,0,5.5-2.86l24,.14A37.28,37.28,0,0,1,462,220a42.43,42.43,0,0,1-22,5.86,43.5,43.5,0,0,1-20.15-4.7,37.69,37.69,0,0,1-14.49-12.73A31,31,0,0,1,400,190.9,31.74,31.74,0,0,1,405.17,173.41Zm53.08,10.14a18,18,0,0,0-7.36-7.69A21.39,21.39,0,0,0,440,172.94a21,21,0,0,0-11.16,2.85,19.13,19.13,0,0,0-7.13,7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M556.52,224.8H536.37V189q0-8.31-3.33-12.18t-10.62-3.88q-7.27,0-10.61,3.88T508.47,189v35.8H488.32V189q0-16.6,9.3-25t24.8-8.37q15.51,0,24.8,8.37t9.3,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M639.53,208.4A37.58,37.58,0,0,1,625,221.19a44.9,44.9,0,0,1-40,0,38.18,38.18,0,0,1-14.57-12.79,31.38,31.38,0,0,1,0-35.26A38.18,38.18,0,0,1,585,160.35a43.05,43.05,0,0,1,20-4.7q11.31,0,19.53,5.17V129.51h20.31v61.26A31.42,31.42,0,0,1,639.53,208.4ZM590.78,178a17.31,17.31,0,0,0,0,25.46,20.1,20.1,0,0,0,14.1,5.1,20.66,20.66,0,0,0,14.26-5.1,17,17,0,0,0,0-25.46,20.66,20.66,0,0,0-14.26-5.1A20.1,20.1,0,0,0,590.78,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.76,146.46a9.68,9.68,0,0,1-3.49-7.55,9.54,9.54,0,0,1,3.49-7.42,12.58,12.58,0,0,1,8.6-3.06,12.36,12.36,0,0,1,8.45,3.06,9.5,9.5,0,0,1,3.49,7.42,9.64,9.64,0,0,1-3.49,7.55,12.36,12.36,0,0,1-8.45,3.06A12.58,12.58,0,0,1,660.76,146.46Zm-1.47,10.28h20.15V224.8H659.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741,224.8l-16-20.69L708.89,224.8H686l27.59-35.39-25.27-32.67H710.9l14,18.1L739,156.74h22.63l-25.27,32.67,27.44,35.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.09,18a18.13,18.13,0,1,0,18.13,18.13A18.12,18.12,0,0,0,181.09,18Zm9.36,13.66-11.7,11.7a1.91,1.91,0,0,1-2.69,0l-4.28-4.28a1.91,1.91,0,1,1,2.7-2.7l2.93,2.93L187.75,29a1.91,1.91,0,0,1,2.7,2.69Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendixLogo);
export default __webpack_public_path__ + "static/media/AttendixLogo.4c819c044a8f73faf71d920c9a55800b.svg";
export { ForwardRef as ReactComponent };